/**
 * Client-side analytics helpers: kept as the single import point, now inert.
 *
 * The app no longer loads Trodo's browser SDK on itself, so these send
 * nothing and queue nothing. The call sites stay (they are cheap no-ops) so
 * tracking can be pointed somewhere else later without touching every page.
 * Only the PostHog identity reset on logout still does anything.
 */
import { resetPosthogIdentity } from 'shared/utils/posthogClient';
import { forgetSyncedIdentity } from 'shared/utils/authSessionBootstrap';

function safeJsonParse(raw) {
  try {
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/** No-op: kept so existing call sites compile and behave as before. */
export async function trackClientEvent() {}

/** No-op. */
export async function setPeopleProps() {}

/** No-op. */
export async function setPeoplePropsOnce() {}

/** Forget the synced identity and reset PostHog. Call on logout BEFORE clearing localStorage. */
export async function resetIdentity() {
  if (typeof window === 'undefined') return;
  forgetSyncedIdentity();
  resetPosthogIdentity();
}

/** Lightweight read of current user/team for callers that still want it. */
export function getAnalyticsContext() {
  if (typeof window === 'undefined') return { user: null, team: null };
  return {
    user: safeJsonParse(localStorage.getItem('User')),
    team: safeJsonParse(localStorage.getItem('selectedTeamData')),
  };
}
